{
  "jira-pandora.common.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-pandora.common.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-pandora.common.project-access-email.banner.alt": [
    {
      "type": 0,
      "value": "Jira banner image"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.body": [
    {
      "type": 0,
      "value": "Your admin rejected your request for "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.heading": [
    {
      "type": 0,
      "value": "Your admin rejected your request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.reason": [
    {
      "type": 0,
      "value": "Reason from your admin"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.redacted.body": [
    {
      "type": 0,
      "value": "Your admin rejected your app request."
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.redacted.heading": [
    {
      "type": 0,
      "value": "Your app request was rejected"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.redacted.subject": [
    {
      "type": 0,
      "value": "Your app request was rejected"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.email.subject": [
    {
      "type": 0,
      "value": "Your admin rejected your request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-internal-app-request-rejection.notification-drawer.message": [
    {
      "type": 0,
      "value": "Your admin rejected your request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.body": [
    {
      "type": 0,
      "value": "Your request for "
    },
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " has been sent to your admin."
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.heading": [
    {
      "type": 0,
      "value": "You requested "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.redacted.body": [
    {
      "type": 0,
      "value": "Your app request has been sent to your admin."
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.redacted.heading": [
    {
      "type": 0,
      "value": "Your app request was submitted"
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.redacted.subject": [
    {
      "type": 0,
      "value": "Your app request was submitted"
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.email.subject": [
    {
      "type": 0,
      "value": "You requested "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-internal-app-request-submission.notification-drawer.message": [
    {
      "type": 0,
      "value": "You requested "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "At Atlassian, we use Jira to plan and manage work. We created a Jira board to help you manage your onboarding to-do list (you may have a separate list if you’re in TEAM Camp). This Jira board is filled with tasks, required to-do's, and recommended content. You can think of it as your personal tracker for the onboarding process! Follow it each day and be sure to mark items complete."
    }
  ],
  "jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "Hi Newlassian, welcome to Jira!"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.body.content": [
    {
      "type": 0,
      "value": "You can now access "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.body.redacted.content": [
    {
      "children": [
        {
          "type": 0,
          "value": "You can now access your Jira project"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.button.redacted.text": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.button.text": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "You've been granted access to your project"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.subject": [
    {
      "type": 0,
      "value": "You've been granted access to "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.content": [
    {
      "type": 0,
      "value": "Users have requested to join "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.redacted.content": [
    {
      "children": [
        {
          "type": 0,
          "value": "Users have requested to join your Jira project"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.redacted.text": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.text": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "Access request for your project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "Access request for "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-sprints-auto-managed-feature-discovery.spotlight-content": [
    {
      "type": 0,
      "value": "Sprints can now start and complete automatically based on their scheduled dates."
    }
  ],
  "jira-sprints-auto-managed-feature-discovery.spotlight-cta-button-label": [
    {
      "type": 0,
      "value": "See how"
    }
  ],
  "jira-sprints-auto-managed-feature-discovery.spotlight-headline": [
    {
      "type": 0,
      "value": "Automate your sprint transitions"
    }
  ]
}